

module.exports = __webpack_require__.stylable.create(
    "suggestion1417895888",
    {"classes":{"root":"suggestion1417895888__root","lineClamp":"suggestion1417895888__lineClamp","content":"suggestion1417895888__content","thumbnail":"suggestion1417895888__thumbnail","title":"suggestion1417895888__title","description":"suggestion1417895888__description"},"vars":{},"stVars":{"lineSize":"3"},"keyframes":{}},
    "",
    3,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/Suggestion/Suggestion.st.css */ 622,
    null
);
